import { PeriodProvider } from "@/providers/Period";
import { TruckIcon } from "@phosphor-icons/react";
import { lazy, Suspense } from "react";

const ComparacaoPedidos = lazy(() => import("./ComparacaoPedidos"));
const VisualizarRelatorioModal = lazy(
  () => import("./ComparacaoPedidos/Components/ModalVisualizar"),
);
const GeracaoPedido = lazy(() => import("./GeracaoPedido"));
const Itens = lazy(() => import("./GeracaoPedido/Itens"));
const Notas = lazy(() => import("./GeracaoPedido/Notas"));
const Resumo = lazy(() => import("./GeracaoPedido/Resumo"));
const GestaoEmbarque = lazy(() => import("./GestaoEmbarque"));
const GestaoExpedicao = lazy(() => import("./GestaoExpedicao"));
const LiberacaoEmbarque = lazy(() => import("./LiberacaoEmbarque"));
const LiberacaoPedidos = lazy(() => import("./LiberacaoPedidos"));
const ConferenciaPage = lazy(() => import("./Conferencia"));
const AreaConferencia = lazy(
  () => import("./Conferencia/components/AreaConferencia"),
);
const PainelExpedicao = lazy(() =>
  import("./Painel").then((m) => ({ default: m.PainelExpedicao })),
);
const RelatorioExpedicao = lazy(() => import("./RelatorioExpedicao"));
const ExpedicoesDashboard = lazy(async () => import("./Dashboard"));

const Module = {
  menuItem: {
    to: "/expedicoes",
    title: "Expedições",
    icon: TruckIcon,
    id: 7,
    childrens: [
      {
        to: "/expedicoes/dash",
        title: "Dashboard",
        fullTitle: "Dashboard",
        id: 27,
      },
      {
        to: "/expedicoes/gestao-expedicao",
        title: "Gestao",
        fullTitle: "Gestao",
        id: 28,
      },
      {
        to: "/expedicoes/conferencia",
        title: "Conferência",
        fullTitle: "Conferência",
        id: 29,
      },
      {
        to: "/expedicoes/relatorio-expedicao",
        title: "Rel. Expedição",
        fullTitle: "Relatório de Expedição",
        id: 30,
      },

      {
        to: "/expedicoes/geracao-de-pedidos",
        title: "Gerar Pedidos",
        fullTitle: "Gerar Pedidos",
        id: 31,
      },
      {
        to: "/expedicoes/comparacao-pedidos",
        title: "Comparação Pedidos",
        fullTitle: "Comparação Pedidos",
        id: 32,
      },
      {
        to: "/expedicoes/liberacao-de-pedidos",
        title: "Liberação de Pedidos",
        fullTitle: "Liberação de Pedidos",
        id: 81,
      },
    ],
  },

  routes: [
    {
      path: "/expedicoes/gestao-expedicao",
      element: (
        <PeriodProvider>
          <GestaoExpedicao />
        </PeriodProvider>
      ),
    },
    {
      path: "/expedicoes",
      element: <PainelExpedicao />,
    },
    {
      path: "/expedicoes/conferencia",
      element: (
        <PeriodProvider>
          <ConferenciaPage />
        </PeriodProvider>
      ),
      children: [
        {
          path: ":id/:idEstacao",
          element: <AreaConferencia />,
        },
      ],
    },
    {
      path: "/expedicoes/relatorio-expedicao",
      element: <RelatorioExpedicao />,
    },
    {
      path: "/expedicoes/dash",
      element: (
        <Suspense
          fallback={
            <>
              <div
                style={{
                  background: "#ccc",
                  height: "100vh",
                  width: "100vw",
                }}
              />
              ...
            </>
          }
        >
          <PeriodProvider>
            <ExpedicoesDashboard />
          </PeriodProvider>
        </Suspense>
      ),
    },
    {
      path: "/expedicoes/geracao-de-pedidos",
      element: (
        <PeriodProvider>
          <GeracaoPedido />
        </PeriodProvider>
      ),
      children: [
        {
          path: "",
          element: <Notas />,
        },
        {
          path: ":notaId/itens",
          element: <Itens />,
        },
        {
          path: ":notaId/resumo",
          element: <Resumo />,
        },
      ],
    },
    {
      path: "/expedicoes/comparacao-pedidos",
      element: (
        <PeriodProvider>
          <ComparacaoPedidos />
        </PeriodProvider>
      ),
      children: [{ path: ":id", element: <VisualizarRelatorioModal /> }],
    },
    {
      path: "/expedicoes/liberacao-embarque",
      element: (
        <PeriodProvider>
          <LiberacaoEmbarque />
        </PeriodProvider>
      ),
    },
    {
      path: "/expedicoes/liberacao-de-pedidos",
      element: <LiberacaoPedidos />,
    },
    {
      path: "/expedicoes/gestao-embarque",
      element: (
        <PeriodProvider>
          <GestaoEmbarque />
        </PeriodProvider>
      ),
    },
  ],
};

export default Module;
